import { intersection, isEmpty, keys, toPairs, uniq } from "lodash-es";
import type { DeepRequired, FieldErrorsImpl } from "react-hook-form";
import toast from "react-hot-toast";
import { notEmpty } from "../../../../utils/not-empty";
import type { MomentFormMoment } from "../../types/moment-form-moment";

export function toastErrors(
  errors: FieldErrorsImpl<DeepRequired<Omit<MomentFormMoment, "dynamic_segment_id_map">>>,
): void {
  const basicErrorFields = ["title", "program_id"];
  const onlyBasicErrors = !isEmpty(intersection(keys(errors), basicErrorFields));
  uniq(
    toPairs(errors)
      .map(([field, error]) =>
        onlyBasicErrors ? (basicErrorFields.includes(field) ? error.message : null) : error.message,
      )
      .filter(notEmpty),
  ).forEach((x) => toast.error(x));
}
